import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { closeToast, useToastTrigger } from "@utils/toastStore";

const DEFAULT_DURATION = 4000;

const ToastHostCst: React.FC = () => {
  const trigger = useToastTrigger();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={!!trigger}
      autoHideDuration={trigger?.duration ?? DEFAULT_DURATION}
      onClose={closeToast}
    >
      {trigger ? (
        <Alert
          onClose={closeToast}
          severity={trigger.severity}
          variant="filled"
          sx={{
            borderRadius: "10px",
            fontWeight: 600,
            minWidth: 280,
          }}
        >
          {trigger.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default ToastHostCst;
